export const GRAPHQL_API_PATH = '/api/graphql';
